import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * EmptyCartComponent
 *
 * Presentational empty state for the billing cart: tells the cashier how to add the first item
 * and which keys focus the scan / search fields.
 */
@Component({
  selector: 'app-empty-cart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './empty-cart.component.html',
  styleUrls: ['./empty-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyCartComponent {
  /** Barcode scanning is enabled for this client (shows the Ctrl+1 hint). */
  @Input() barcodeEnabled = false;
}
